import { Grid, Typography, Button, Box } from "@mui/material";
import { InputFormMaskTel } from "./InputFormMaskTel";
import { FormProvider, useForm } from "react-hook-form";
import { useServiceWhatsApp } from "hooks/servicioWhastApp/useWhatsApp";
import { LoadingButton } from "@mui/lab";
import { InputFormMaskPin } from "./InputFormMaskPin";
import SaveIcon from "@mui/icons-material/Save";

export const InputNumeroCelular = () => {
  const methods = useForm();
  const {
    pinSent,
    loading,
    pinRequeted,
    telefonoWhatsapp,
    starGetSentPin,
    notify,
    startGetGuardarNumero,
    setContentModal,
  } = useServiceWhatsApp();

  const theme = localStorage.getItem("typeTheme");

  const onsumbit = (data: any) => {
    const unmaksed = data.telefono.replace(/[^\d]/g, "");
    starGetSentPin(unmaksed);
  };

  const confirmPinSubmit = (data: any) => {
    const unmaksed = data.telefono.replace(/[^\d]/g, "");
    if (data.pin.length < 6) {
      notify("El pin debe tener 6 digitos", "error");
      return;
    }
    if (Number(data.pin) === pinRequeted) {
      startGetGuardarNumero(unmaksed);
    } else {
      notify("El pin no es correcto", "error");
    }
  };

  return (
    <FormProvider {...methods}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Grid item xs={12}>
          <Typography variant="body1" component="div" gutterBottom>
            {pinSent
              ? `Porfavor, Ingresa el PIN que hemos enviado al numero ${
                  telefonoWhatsapp?.slice(0, 3) + " *******"
                }`
              : "A continuación ingresa el número de celular al que deseas recibir tus notificaciones vía WhatsApp."}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            my: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <InputFormMaskTel
            label=""
            name="telefono"
            size={"medium"}
            rules={{
              required: {
                value: true,
                message: "Telefono es requerido",
              },
              minLength: {
                value: 14,
                message: "Telefono debe tener 10 digitos",
              },
            }}
            sx={{
              borderRadius: "5px",
              marginY: "10px",
              padding: "0px",
              width: "50%",
              boxShadow: "0 10px 35px rgba(0, 0, 0, 0.2)",
              border: "0px solid #000000",
            }}
          />
          {pinSent && (
            <Box
              sx={{
                my: 2,
              }}
            >
              <InputFormMaskPin
                label=""
                name="pin"
                validChars="0123456789"
                classNames={{
                  character: theme
                    ? theme === "dark"
                      ? "character-dark"
                      : "character-light"
                    : "character-light",
                  characterSelected: "character-selected",
                }}
                size={"medium"}
              />
            </Box>
          )}
        </Grid>
        <Grid item container xs={12} spacing={2} justifyContent={"center"}>
          <Grid item xs={12}></Grid>
          <Grid item>
            {pinSent ? (
              <LoadingButton
                loading={loading}
                variant="outlined"
                loadingPosition="start"
                onClick={methods.handleSubmit(onsumbit)}
                startIcon={<SaveIcon />}
              >
                {loading ? "Enviando..." : "Enviar Nuevamente"}
              </LoadingButton>
            ) : (
              <Button
                variant="outlined"
                disabled={loading}
                onClick={() => setContentModal("avisoDePrivacidad")}
              >
                Regresar
              </Button>
            )}
          </Grid>
          <Grid item>
            {pinSent ? (
              <LoadingButton
                loading={loading}
                variant="contained"
                loadingPosition="start"
                onClick={methods.handleSubmit(confirmPinSubmit)}
                startIcon={<SaveIcon />}
              >
                {loading ? "Confirmando..." : "Confirmar PIN"}
              </LoadingButton>
            ) : (
              <LoadingButton
                loading={loading}
                variant="contained"
                loadingPosition="start"
                onClick={methods.handleSubmit(onsumbit)}
                startIcon={<SaveIcon />}
              >
                {loading ? "Enviando..." : "Enviar"}
              </LoadingButton>
            )}
          </Grid>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
